import { buttonRegexpPattern } from "./parsingChatMessageButtons";

// получаем строку без переносов и лишних пробелов и кнопок по краям из массива строк
const getStringWithoutLinesAndExtraSpacesAndButtonsFromArray = (messages: string[]): string => {
	return messages.join("").replace(buttonRegexpPattern, "").replace(/\n/g, " ").trim();
};

export default getStringWithoutLinesAndExtraSpacesAndButtonsFromArray;
